import {
  UPDATE_COMPANY,
  UPDATE_COMPANY_VALID_EMAILS,
  UPDATE_IP_LOGIN_COMPANY_ANALYTICS_INFO
} from '@store/mutation-types';

const mutations = {
  [UPDATE_COMPANY](state, company) {
    state.company = company;
  },
  [UPDATE_COMPANY_VALID_EMAILS](state, validEmails) {
    state.validEmails = validEmails || [];
  },
  [UPDATE_IP_LOGIN_COMPANY_ANALYTICS_INFO](state, ipLoginCompanyAnalyticsInfo) {
    state.ipLoginCompanyAnalyticsInfo = ipLoginCompanyAnalyticsInfo || {};
  }
};

const actions = {};

const store = {
  namespaced: true,
  // publication and product of the company
  state: {
    company: {

    },
    validEmails: [],
    ipLoginCompanyAnalyticsInfo: {}
  },
  mutations,
  actions,
};

export { store as corporateStore };
